<template>
	<AppDialog
		closeTop="-30"
		width="625"
		height="700"
		closeRight="-2"
		disable-max-width
		ref="dialog_container"
		:dialogName="'AnalyticsEventTrackingItemDialog'"
	>
		<div class="p-[30px] h-[750px] flex flex-col justify-between overflow-auto">
			<div class="grow">
				<v-row no-gutters align="center" class="list_item">
					<v-col cols="auto">
						<div class="w-[40px] h-[40px] border-[#D9D9D9] border rounded-md grid">
							<v-img class="place-self-center" :src="configurationProvider.icon" :width="20" />
						</div>
					</v-col>
					<v-col class="pl-3 h-full justify-between flex-col mb-[8px]">
						<h3 class="d_name light">
							<span class="text-[20px] font-semibold text-[#1B1C21]">{{ configurationItem.title }}</span>
						</h3>
						<p class="display-flex flex-row flex-align-center text-[12px] text-[#646E87]">{{ configurationProvider.provider_name }}</p>
					</v-col>
					<v-col class="text-right">
						<div class="test_wrpr text-right">
							<span class="text-[#6060F7] text-[14px] cursor-pointer underline" @click="openSettings">Edit destination</span>
						</div>
					</v-col>
					<div class="text-[12px] text-[#646e87]">Send events to this destination by adding an "event mapper" step in your feature</div>

					<v-col cols="12" class="mt-3 mb-1"> </v-col>
				</v-row>
				<v-row no-gutters align="center" class="list_item border-b border-[#EBEBEB] pb-[18px]">
					<v-col cols="auto">
						<div class="text-[#262626] text-[16px] font-semibold">Event templates</div>
						<div class="text-[12px] text-[#646e87]">Define events to sent tracking data to {{ configurationProvider.provider_name }}.</div>
						<div class="text-[12px] text-[#646e87]">Optionally, add parameters that let you map data from your features.</div>
					</v-col>
					<v-col class="text-right">
						<div class="test_wrpr text-right">
							<OutlinedButton
								class="add-event-button"
								@click="
									() => {
										openEventEditDialog(null, configurationProvider, pixelConfiguration);
									}
								"
								>Add event</OutlinedButton
							>
						</div>
					</v-col>
				</v-row>
				<EventList :events="configurationItem.events" @openEvent="openEventEditDialog" @deleteEvent="deleteEvent" />
			</div>
			<div class="dialog-content flex flex-col items-center justify-end pt-[30px]">
				<PrimaryButton class="text-[14px] font-normal w-[140px]" @click="close">Close</PrimaryButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import EventList from './AnalyticsEventTrackingItemDialog/EventList';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { fetchAnalyticsProviders, deleteAnalyticsEvent } from '@/store/modules/analyticsProvider/actions';
import { useAnalyticsConfigurations, useAnalyticsProvidersArray } from '@/store/modules/analyticsProvider/getters';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'AnalyticsEventTrackingItemDialog',
	props: { pixelConfiguration: { type: Object } },
	components: {
		AppDialog,
		EventList,
	},
	methods: {
		...mapActionsShorthand({ fetchAnalyticsProviders, deleteAnalyticsEvent }),
		close() {
			AppDialogManagerService.closeCurrentDialog();
		},
		openSettings() {
			this.close();
			AppDialogManagerService.openAnalyticsEventTrackingSettingsDialog({ currentConnection: this.pixelConfiguration });
		},
		openEventEditDialog(event) {
			this.close();
			AppDialogManagerService.openAnalyticsCustomEventDialog({
				event,
				provider: this.configurationProvider,
				pixelConfiguration: this.pixelConfiguration,
			});
		},
		async deleteEvent(event) {
			try {
				await this.deleteAnalyticsEvent({ analyticsEventId: event.id, analyticsConfiguration: this.configurationItem });
				this.configurationItem = this.useAnalyticsConfigurations.find((item) => item.id === this.pixelConfiguration.id);
			} catch (error) {
				this.$toast.error(error.message);
			}
		},
	},
	computed: {
		...mapGettersShorthand({ useAnalyticsProvidersArray, useAnalyticsConfigurations }),
	},
	data() {
		return {
			configurationProvider: {},
			configurationItem: {},
		};
	},
	created() {
		this.configurationProvider = this.useAnalyticsProvidersArray.find(
			(provider) => provider.id === this.pixelConfiguration.analytics_provider
		);
		this.configurationItem = this.useAnalyticsConfigurations.find((item) => item.id === this.pixelConfiguration.id);
	},
};
</script>

<style scoped lang="scss">
::v-deep {
	.anemic-button {
		background-color: white !important;
	}
	.anemic-button:hover {
		border: 1px solid #d2d7e2 !important;
	}
}
div > button.add-event-button {
	color: #6060f7 !important;
	font-size: 14px !important;
	border-color: #6060f7 !important;
	text-transform: none !important;
	border-radius: 8px !important;
}
</style>
